<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Agency
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.unique_id"
                outlined
                label="Enter User ID"
                prepend-inner-icon="mdi-account-key"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Agency Name"
                prepend-inner-icon="mdi-account-group"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.whatsapp_no"
                outlined
                label="WhatsApp Number"
                prepend-inner-icon="mdi-whatsapp"
              ></v-text-field>
            </v-col>

            <!-- <v-col sm="4">
              <v-select
                v-model="form.status"
                :items="['active', 'inactive']"
                label="Status"
                outlined
                prepend-inner-icon="mdi-toggle-switch"
              ></v-select>
            </v-col> -->

            <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (agency_path = null)"
              >
                Remove
              </v-btn>

              <div id="preview" v-if="agency_path" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img :src="agency_path" style="height: 30%; width: 30%" />
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Agency
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "AgencyCreatePage",
  data() {
    return {
      form: {
        unique_id: "",
        name: "",
        is_portal: true,
        whatsapp_no: "",
        source_type: "Admin",
        status: "active",
      },
      agency_path: "",
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        let res = await axios.post("/agencies", this.form);
        this.createdAgency = res.data.data;

        await this.handleFileUpload();
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        console.error(e);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file && this.$refs.file.files.length > 0) {
        let attachment = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append("id", this.createdAgency.id);
        formData.append("agency_path", attachment);
        await axios.post("upload_agency_image", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }
    },
    onFileChange() {
      this.file = this.$refs.file?.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          this.agency_path = URL.createObjectURL(this.file);
        };
        img.src = evt.target.result;
      };
      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
  },
};
</script>
